import React from "react"
import { Redirect, withRouter } from "react-router-dom"
import { Table } from "semantic-ui-react"
import { withTranslation } from "react-i18next"

@withTranslation()
@withRouter
class CashboxInfo extends React.Component {
  render() {
    const { t } = this.props
    return (
      <>
        {/* <h2>{this.props.location.state}</h2> */}
        <div className="cashbox-div-content">
          <div className="kassa_info">
            <h3 style={{ textAlign: "center", marginTop: "5px" }}>
              {t("cashboxInfo")}
            </h3>
            <Table striped>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{t("idNumber")}</Table.Cell>
                  <Table.Cell>8568</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("factoryNumber")}</Table.Cell>
                  <Table.Cell>SWK00020099</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("cashboxDescription")}</Table.Cell>
                  <td style={{ overflowWrap: "break-word" }} />
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("registrationNumber")}</Table.Cell>
                  <Table.Cell>201610170001</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("dateRegister")}</Table.Cell>
                  <Table.Cell>17.10.2016</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("wayEnterDiscount")}</Table.Cell>
                  <Table.Cell>%</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("defaultIndustry")}</Table.Cell>
                  <Table.Cell>Торговая сфера</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>{t("purchaseMode")}</Table.Cell>
                  <Table.Cell>{t("switchedOn")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("markup")}</Table.Cell>
                  <Table.Cell>{t("switchedOn")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("serviceCenter")}</Table.Cell>
                  <Table.Cell>
                    <a
                      href="http://webkassa.kz/contacts.html?cto=cto"
                      target="blank"
                    />
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("activationPackage")}</Table.Cell>
                  <Table.Cell>{t("isAbsent")}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("modeOperation")}</Table.Cell>
                  <Table.Cell>Режим отправки в ОФД </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("CRF")}</Table.Cell>
                  <Table.Cell>
                    <label>АО &quot;Казахтелеком&quot;</label>
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("confirmCode")}</Table.Cell>
                  <Table.Cell>2G5F0C8X</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </div>

          <div className="kassa_info">
            <h3 style={{ textAlign: "center", marginTop: "5px" }}>
              {t("shiftInfo")}
            </h3>
            <Table striped>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>{t("shiftNumber")}</Table.Cell>
                  <Table.Cell>12</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("shiftOpening")}</Table.Cell>
                  <Table.Cell>05.12.2016 17:07</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("cashOnHand")}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("numberOfSales")}</Table.Cell>
                  <Table.Cell>0 чеков на сумму 0,00 тг</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("returnSales")}</Table.Cell>
                  <Table.Cell>0 чеков на сумму 0,00 тг</Table.Cell>
                </Table.Row>

                <Table.Row>
                  <Table.Cell>{t("cashSales")}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("cardSale")}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("numberOfPurchases")}</Table.Cell>
                  <Table.Cell>0 чеков на сумму 0,00 тг</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("numberOfRefunds")}</Table.Cell>
                  <Table.Cell>0 чеков на сумму 0,00 тг</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("deposit")}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("withdrawal")}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{`${t("sum")} ${t("VAT")}`}</Table.Cell>
                  <Table.Cell>0,00</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("numberOfDocuments")}</Table.Cell>
                  <Table.Cell>5</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>{t("shiftClosing")}</Table.Cell>
                  <td />
                </Table.Row>
              </Table.Body>
            </Table>
          </div>
        </div>
      </>
    )
  }
}

export default CashboxInfo
